import { useEffect } from 'react';
import { useEvieChatStore } from '@/store/evieChat';

/**
 * /assistant — legacy deep-link shim. The in-app entry points (map quick
 * actions, Help CTA) open the global AppShell-mounted sheet directly now,
 * so nothing in-app routes here; old bookmarks and external links still
 * land. Opens the sheet and REPLACES this history entry with /map (a push
 * would leave the shim in the back stack: every Back press would re-enter
 * it, force-reopen the sheet, and push /map again — an inescapable trap).
 * The manual popstate dispatch runs App's listener so the path state
 * syncs without adding an entry.
 */
export function AssistantPage() {
  const openSheet = useEvieChatStore((s) => s.openSheet);
  useEffect(() => {
    openSheet();
    window.history.replaceState({}, '', '/map');
    window.dispatchEvent(new PopStateEvent('popstate'));
  }, [openSheet]);
  return null;
}
